import { css } from 'styled-components';

const PhotoUploaderModalFooter = css`
  .legoButton {
    min-width: 120px;
    &:first-child {
      background-color: transparent;
      color: ${({ theme }) => theme.colors.healthLight30};
      border: 1px solid ${({ theme }) => theme.colors.healthLight30};
    }
  }
`;

export default PhotoUploaderModalFooter;
